import { render, staticRenderFns } from "./logo.svg.vue?vue&type=template&id=2431a94e&scoped=true&"
import script from "./logo.svg.vue?vue&type=script&lang=js&"
export * from "./logo.svg.vue?vue&type=script&lang=js&"
import style0 from "./logo.svg.vue?vue&type=style&index=0&id=2431a94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2431a94e",
  null
  
)

export default component.exports